import React from "react"

import CompaniesCollection from "../../../../../core/gd-model/tree/companies-collection"
import HeaderAppTitle from "../../common/app-title/app-title"
import {BUS_TREE_CHANGE, SESSION_PROJECT_CHANGE} from "../../../../../core/gd/bus/bus-event-type"
import ProjectSession from "../../../../../core/model2/project/project-session"
import {ProjectTree} from "../../../../../core/gd-model/tree/@type"
import ProjectIconUI5 from "../../../../../core/gd-components/icons/project/project-icon-ui5"
import {ItemIconSize} from "../../../../../core/gd-components/icons/@const"
import {ViewType} from "../../../../../core/gd/const/views/view-type"

type Props = {
    projectId               : ID
    onChange?               : func
}

// const debug = "ProjectTitle"
const debug = false

export default class ProjectTitle extends React.Component<Props, any> {

    // Combined property for shouldComponentUpdate-related values
    private shouldUpdateProps: {
        currentViewType?     : ViewType // is required to update title-mark if necessary
    } = {}

    constructor(props: Props) {
        super(props)

        const { project, parents, isEditable } = this.init(props.projectId)

        this.state = {
            project     : project,
            parents     : parents,
            isEditable  : isEditable
        }
    }

    componentDidMount() {
        gd.bus.subscribe(SESSION_PROJECT_CHANGE, this, this.onProjectChanged)
        gd.bus.subscribe(BUS_TREE_CHANGE, this, this.updateParents)

        this.shouldUpdateProps.currentViewType = gd.projectViews.currentView?.type // project custom views has no currentView
    }

    shouldComponentUpdate(nextProps: Props, nextState: any) {
        const res =
            !_.isEqual(nextState, this.state)
            || nextProps.projectId !== this.props.projectId
            || this.shouldUpdateProps.currentViewType !== gd.projectViews.currentView?.type // project custom views has no currentView

        this.shouldUpdateProps.currentViewType = gd.projectViews.currentView?.type

        return res
    }

    UNSAFE_componentWillReceiveProps(newProps: Props) {
        if (newProps.projectId === this.props.projectId) return false

        this.updateState(newProps.projectId)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    updateParents = () => {this.updateState(this.props.projectId)}

    updateState = (projectId: ID) => {
        const { project, parents, isEditable } = this.init(projectId)

        this.setState({
            project     : project,
            parents     : parents,
            isEditable  : isEditable
        })
    }

    onProjectChanged = (projectId: ID) => {
        if (this.state.project && this.state.project.id === projectId) {
            this.forceUpdate()
        }
    }

    init(projectId: ID) {
        // parents tree
        let parentTreeSource = new CompaniesCollection([gd.session.companies.get(gd.companyId)]);
        parentTreeSource.resetCompanyProjects(gd.companyId, {
            silent: true,
            includeArchived: true
        })

        const treeProject   = parentTreeSource.getProject(projectId)
        const project       = gd.session.projects.get(projectId)
        let parents: any = false

        if (!treeProject && (!project || !project.isTemplate)) {
            // do nothing (most likely project is deleted)
        } else {

            const filterProjects =
                // []
                // .concat(parentTreeSource.findProjectParents(treeProject)
                parentTreeSource.findProjectParents(treeProject)
                    .filter((p: ProjectTree)=>{ return gd.company.settings.projectAccess.showParentsDespiteAccess || !!p.access })
                    .map(
                        (p: ProjectTree)=>{
                            return {item:p}
                        })
                .slice(-2)

            if (filterProjects && filterProjects.length>0) {
                parents = filterProjects
            }
        }

        // EDITABLE
        const isEditable = gd.ac.check.project.fullAccess(projectId, project)

        return {
            project     : project,
            parents     : parents,
            isEditable  : isEditable
        }
    }

    onParentClick = (project: ProjectSession) => {
        debug && console.log(debug, 'onParentClick', project.properties?.handleExpandInsteadOfOpen, project)

        project.goTo()

        // if (!project.access || project.properties?.handleExpandInsteadOfOpen) return
        // this.props.onParentProjectClick(project.id)
    }

    onBlur = (newValue: any) => {
        if (!newValue || newValue.trim() === "") {
            return
        }

        this.state.project.name = newValue

        this.setState({
            project: this.state.project
        }, ()=>{
            // gd.api.Project.updateProfile(this.props.projectId, {name: newValue})
            gd.api.Project.update(this.props.projectId, {name: newValue})
        })
    }

    render() {
        const isEverythingView = this.state.project.isWorkspace && gd.projectViews.currentView?.type !== ViewType.PROJECT_NO_VIEWS // project custom views has no currentView

        debug && console.log(debug, 'render', isEverythingView, gd.projectViews.currentView)

        return (
            <>
                {_.map(this.state.parents, (parentProject: any, key: number)=>{
                    const classes = Classes("parent-project max-w-150", {
                        'no-hover': !parentProject.item.access
                    })
                    return (
                        <React.Fragment key={parentProject.item.id}>
                            <div className  = {classes}
                                 onClick    = {() => {
                                     this.onParentClick(gd.session.projects.get(parentProject.item.id)!)
                                 }}>
                                {parentProject.item.name}
                            </div>
                            <div className="arrow-separator ui5-arrow-toggle s7 closed"/>
                        </React.Fragment>
                    )
                })}

                {this.state.project &&
                    <>
                        <ProjectIconUI5
                            project     = {this.state.project}
                            colorize    = {true}
                            size        = {ItemIconSize.SIZE_16}
                        />

                        <HeaderAppTitle
                            name        = {this.state.project.name}
                            editable    = {this.state.isEditable}
                            onChange    = {this.onBlur}
                        />

                        {this.state.project.isTemplate &&
                            <div className="title-mark">template</div>}

                        {this.state.project.isArchived &&
                            <div className="title-mark">archived</div>}

                        {isEverythingView &&
                            <div className="title-mark ui5-txt-no-accent-small txt-semibold no-accent">Everything</div>}
                    </>}
            </>
        );
    }
}
